import { queryOptions, useQuery } from '@tanstack/react-query';

import { StaleTime } from 'queries/types';
import { ACCOUNT_PREFIX } from 'restful/accounts/constants';
import { restCall } from 'services/api/restful/client';
import { RestApiError } from 'services/api/restful/errors';
import { getAddresses } from 'services/api/restful/generated/accounts/accounts';
import type { Address } from 'services/api/restful/generated/nofomoRestApi.schemas';

type AccountAddressesQueryData = { addresses: Array<Address> };

export const accountAddressesQuery = queryOptions<
  AccountAddressesQueryData,
  RestApiError
>({
  queryKey: [ACCOUNT_PREFIX, 'addresses'],
  queryFn: async () => {
    const { data } = await restCall(() => getAddresses());
    return { addresses: data };
  },
});

export const useAccountAddresses = () => {
  const query = useQuery({
    staleTime: StaleTime.ONE_HOUR,
    ...accountAddressesQuery,
  });

  return {
    // For now there is only one address
    address: query.data?.addresses?.[0],
    isLoading: query.isLoading,
  };
};
